import { ControlValueAccessor, UntypedFormControl, FormBuilder, Validators, UntypedFormGroup, NG_VALUE_ACCESSOR } from "@angular/forms";
import { Log } from 'ng2-logger';

import { Component, Input, OnChanges, OnInit, DoCheck, SimpleChanges, Output,
         EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef, AfterViewChecked } from "@angular/core";

@Component({
    selector: "app-multiple-input",
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: MultipleInputComponent,
            multi: true
        }
    ],
    templateUrl: "./multiple-input.component.html",
    styleUrls: ["./multiple-input.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultipleInputComponent implements OnInit, OnChanges, DoCheck, AfterViewChecked, ControlValueAccessor {
    _logger = Log.create(MultipleInputComponent.name);

    @Input() placeholder;
    @Input() inputs: any[] = [];
    @Input() label: string;
    @Input() formControl: UntypedFormControl;
    @Input() showErrors = true;
    @Input() labelAlign = "top";
    @Input() type = "text";
    @Input() pattern: string | RegExp | null = '^[0-9]*$';

    @Output() inputChange = new EventEmitter<any>();

    formGroup: UntypedFormGroup[] = [];

    private onChangeCallback: (_: any) => {};
    private onTouchedCallback: (_: any) => {};

    constructor(private cdr: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.resetForm();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.inputs) {
            this.resetForm();
        }
    }

    ngDoCheck(): void {
        if (this.onChangeCallback) {
            this.onChangeCallback(this.inputs);
            this.inputChange.emit(this.inputs);
        }
    }

    ngAfterViewChecked(): void {
        this.cdr.detectChanges();
    }

    get isValid() {
        let isFormGroupValid = true;
        this.formGroup.forEach(group => {
            isFormGroupValid = isFormGroupValid && group.valid;
        })
        this.showErrors = !isFormGroupValid;
        return isFormGroupValid;
    }

    init(values) {
        if (!values) {
            this.resetForm();
            return;
        }
        this.formGroup = [];
        values.forEach(value => {
            this.formGroup.push(new UntypedFormGroup({
                name: new UntypedFormControl(value.name, this.buildValidators())
            }))
        })
    }

    resetForm() {
        this.formGroup = [new UntypedFormGroup({
            name: new UntypedFormControl('', this.buildValidators())
        })];
        this.inputs = [{id: null, name: ''}];
    }

    addInput() {
        this.inputs = [
            ...this.inputs,
            { id: null, name: '' }
        ];
        this.formGroup.push(new UntypedFormGroup({
            name: new UntypedFormControl('', this.buildValidators())
        }));
        if (this.onChangeCallback) {
            this.onChangeCallback(this.inputs);
        }
    }

    removeInput(index: number) {
        this.inputs.splice(index, 1);
        this.formGroup.splice(index, 1);
        if (this.onChangeCallback) {
            this.onChangeCallback(this.inputs);
        }
    }

    writeValue(value: any) {
    }

    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }

    private buildValidators() {
        const validators = [Validators.required];
        if (this.pattern) {
            validators.push(Validators.pattern(this.pattern));
        }
        return validators;
    }
}
